export default __webpack_public_path__ + "6d84c07c070d4888c3991eaf74365f5b.png";